export const ROLL_OUTCOMES=Object.freeze([
  {value:1,name:'Rescue Turn',minutes:3,face:'cloud',label:'just make contact',description:'Make contact with the task. Open it, breathe, move one thing. That is enough.'},
  {value:2,name:'Tiny Turn',minutes:5,face:'tiny-heart',label:'tiny first move',description:'Make the first move small enough that your brain stops arguing with it.'},
  {value:3,name:'Setup Turn',minutes:7,face:'flower',label:'set the stage',description:'Do not do the whole task. Set up the space, file, tools, or first step.'},
  {value:4,name:'Prep Turn',minutes:10,face:'star',label:'prepare one piece',description:'Prepare one contained piece. You are allowed to stop after preparation.'},
  {value:5,name:'Focus Turn',minutes:15,face:'moon',label:'one focus sprint',description:'One short focused sprint. No perfect finish required.'},
  {value:6,name:'Hero Turn',minutes:20,face:'heart-sparkle',label:'one real piece',description:'Choose one real, contained piece and give it a little more room.'}
].map(Object.freeze));

export function getRollOutcome(value){
  if(!Number.isInteger(value)||value<1||value>6)throw new RangeError('A roll must be an integer from 1 to 6');
  return ROLL_OUTCOMES[value-1];
}
export function smallerDuration(minutes){
  if(minutes>25)return 25;
  if(minutes>=25)return 15;
  if(minutes>=15)return 10;
  if(minutes>=7)return 5;
  if(minutes>3)return 3;
  return 1;
}
